const AdminFinances = () => {
  return (
    <div>
      <h1>Admin Finances</h1>
    </div>
  );
}

export default AdminFinances;